import Navbar from '../Navbar/Navbar'
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {motion} from 'framer-motion'

export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_z1obkbs", 'template_gkh5kjd', form.current, 'HfIaV2JIzYfkqO2V2')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <>
        <motion.div
            initial={{width:0}}
            animate={{width:"100%"}}
            exit={{x: window.innerWidth, transition:{duration:0.1}}}
        >
            <Navbar/>
<h2 className=' pt-5 '>Contact Form</h2>

<div className='card w-75 m-auto mt-5 bg-light'>

            <form ref={form} onSubmit={sendEmail} className='d-flex  row w-75 m-auto p-5 text-start'>
              {/* <div className="card-body d-flex flex-column w-75 m-auto"> */}
              {/* <input className='rounded-1' name="user_email" className='m-2 rounded' type="email" placeholder="Email" />
              <input className='rounded-1' name="user_name" className='m-2 rounded' type="text" placeholder="Name" />

              <input className='rounded-1' name="message" className='m-2 rounded p-2' type="text" placeholder="message" /> */}

              {/* <button className='m-2 btn btn-success rounded' type="submit" value="Send">Send</button></div> */}
      <label className='p-1 '>Name</label>
      <input className='rounded-1' type="text" name="user_name" />
      <label className='p-1'>Email</label>
      <input className='rounded-1' type="email" name="user_email" />
      <label className='p-1'>Phone</label>
      <input className='rounded-1' type="number" name="phone" />
      <label className='p-1'>Message</label>
      <textarea className='rounded-1' name="message" />
      <input  className='bg-success rounded-1 border-success text-white mt-2 w-75 m-auto'  type="submit" value="Send" />

            </form>

<form>

</form>
    </div></motion.div>
</>
  );
};


